import { useSelector } from "react-redux";
import { State } from "../../../../reducers";

import { CreditoFiscal } from "./contents/CreditoFiscal";
import { ComprobanteLiquidacion } from "./contents/ComprobanteLiquidacion";
import { SujetoExcluido } from "./contents/SujetoExcluido";
import { NotaRemision } from "./contents/NotaRemision";
import { NotaCredito } from "./contents/NotaCredito";
import { useHistory } from "react-router-dom";

const RenderDoc = (props: any) => {
  const history = useHistory();

  switch (props.idDoc) {
    case '03':
      return <CreditoFiscal />;
    case '04':
      return <NotaRemision />;
    case '05':
      return <NotaCredito />;
    case '08':
      return <ComprobanteLiquidacion />;
    case '14':
      return <SujetoExcluido />;
    default:
      history.push("/otros-documentos");
      return <div></div>;
  }
};

const DynamicDocContent = () => {
  const {activeDoc} = useSelector((state: State) => state.documentos)
  return (
    <RenderDoc idDoc={activeDoc.idDoc} />
  )
}

export default DynamicDocContent;